// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!

let isMobile = window.matchMedia('(hover:none)').matches;

// trigger shape animations on scroll

let options = {
  root: null,
  threshold: 0.1,
};

const scrollObserver = new IntersectionObserver(callback, options);

const banner = document.querySelector('.banner');
const shapeSections = document.querySelectorAll('.story .shape');

scrollObserver.observe(banner);

shapeSections.forEach((section) => {
  scrollObserver.observe(section);
});

function callback(entries) {
  const [entry] = entries;
  pressPlay(entry);
}

function pressPlay(entry) {
  let section = entry.target;
  if (entry.isIntersecting) {
    section.classList.add('play');
  } else {
    section.classList.remove('play');
  }
}

// electric grid

let numbers = document.querySelectorAll('.number');

numbers.forEach((number) => drawLine(number));

function drawLine(el) {
  let div = el.closest('.story');
  let line = div.querySelector('.line');

  let end = el.getBoundingClientRect();
  let start = div.getBoundingClientRect();
  let width = Math.ceil((end.x - start.x) / 10) * 10;

  css(line, {
    'width': `${width}px`,
    'margin-top': `10px`,
  });
}

window.addEventListener('resize', (event) => {
  numbers.forEach((number) => drawLine(number));
});

function css(element, style) {
  for (const property in style) element.style[property] = style[property];
}

// see more coverage

let more = document.querySelectorAll('.more');

more.forEach((section) => {
  let height = section.clientHeight + 'px';
  let button = section.querySelector('.button');
  if (!isMobile) {
    button.classList.add('hide');
  } else {
    section.classList.add('hide');
    button.setAttribute('aria-expanded', 'false');

    button.addEventListener('click', (event) => {
      let parent = event.target.closest('.more');

      if (parent.classList.contains('hide')) {
        parent.classList.remove('hide');
        button.setAttribute('aria-expanded', 'true');

        parent.querySelector('a').innerHTML = 'See Less Coverage';

        parent.style.setProperty('--height', height);
      } else {
        parent.classList.add('hide');
        button.setAttribute('aria-expanded', 'false');

        parent.querySelector('a').innerHTML = 'See More Coverage';

        parent.style.setProperty('--height', '0');
      }
    });
  }
});

// newsletter sign up

const newsletterForm = document.getElementById('boilingpoint');
const dev = 'https://membership-dev.latimes-test-dss.caltimes.io';
const prod = 'https://membership.latimes.com';

const data = {
  data: {
    type: 'newsletter',
    id: '1245',
    attributes: {},
  },
  meta: {
    email: '',
    signUpSource: 'lat-projects',
  },
};

const msgDiv = document.querySelector('.message');

newsletterForm.addEventListener('submit', async (e) => {
  e.preventDefault();

  let form = e.currentTarget;

  let api = '/subscription-services/v1';
  let action = '/newsletters/subscriptions';
  let url = prod + api + action;

  let formdata = new FormData(form);
  let email = formdata.get('email');

  msgDiv.innerHTML = '';
  quickEmailValidation(email);

  if (!quickEmailValidation(email)) {
    errorMessage('not_an_email');
    return;
  }

  try {
    loading('loading');
    data.meta.email = email;
    const responseData = await postFormDataAsJson({ url, data });

    if (responseData) {
      form.innerHTML = '';
      let success_message = `Thank you! You signed up for ${responseData.data.attributes.name}.`;
      errorMessage('success', success_message);
    }
  } catch (error) {
    console.error(`An error has occured: ${error}`);
    errorMessage('not_valid');
  }
});

function errorMessage(status, success_msg) {
  let msg = msgDiv.appendChild(document.createElement('span'));
  switch (status) {
    case 'not_an_email':
      msg.classList.add('error');
      msg.textContent =
        "Sorry that's not an email address. Please enter an email address.";
      loading();
      break;
    case 'not_valid':
      msg.classList.add('error');
      msg.textContent =
        'Sorry, that email is not valid. Please enter a new address.';
      loading();
      break;
    case 'success':
      msg.classList.add('success');
      msg.textContent = success_msg;
      break;
    default:
      console.log('default');
  }

  setTimeout(() => {
    let errormsg = msgDiv.querySelector('.error');
    if (errormsg) {
      msgDiv.removeChild(errormsg);
    }
  }, 5000);
}

function loading(status) {
  const button = document.querySelector('.submit-container input');
  const ellipse = document.querySelector('.submit-container .ellipses');

  if (status == 'loading') {
    button.value = '';
    ellipse.classList.remove('hidden');
  } else {
    ellipse.classList.add('hidden');
    button.value = 'Sign up for Boiling Point';
  }
}

async function postFormDataAsJson({ url, data }) {
  const fetchOptions = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(url, fetchOptions);

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }

  return response.json();
}

function quickEmailValidation(email) {
  let regx = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}');
  return regx.test(email);
}
